import {apiClient, apiSpaceClient} from "@services/dataSource/lib/api";
import {API_URL} from "@/app/constants/apiUrlInfo";
import {
    LoginPayload,
    MemberAccessPutPayload,
    MemberDeletePayload,
    MemberGetPayload,
    MemberInfoPayload,
    MemberInviteInfoPayload,
    MemberInviteListPayload,
    MemberListGetPayload,
    MemberMePayload,
    MemberPasswordPutPayload,
    MemberPayload,
    MemberPutPayload, MemberResetPasswordPutPayload,
    MemberSignOutPayload,
    MemberStringPutPayload,
    RefreshTokenPayload,
    RoleListGetPayload,
    RolePayload,
    SsoLoginPayload
} from "@services/entities/memberEntity";
import {AxiosRequestConfig} from "axios";

// NEW :: member sign up post Api
export const MemberSignUpPostApi = async<T extends MemberInfoPayload> (params: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.signUp, params);
}

// NEW :: member login post Api
export const MemberLoginPostApi = async<T extends LoginPayload> (params: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.signIn, params);
}

// NEW :: member login post Api
export const MemberMeGetApi = async<T extends MemberMePayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.member.me, {params});
}

// NEW :: member Sso login post Api
export const MemberSsoLoginPostApi = async<T extends SsoLoginPayload> (params: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.sso, params);
}

// NEW :: member refresh token post Api
export const MemberRefreshTokenPostApi = async<T extends RefreshTokenPayload> (config: AxiosRequestConfig): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.refreshToken, {}, config);
}

// NEW :: member sign out post Api
export const MemberSignOutPostApi = async<T extends MemberSignOutPayload> (): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.signOut);
}

// NEW :: member get list Api
export const MemberListGetApi = async<T extends MemberListGetPayload> (params: T): Promise<T['response']> => {
    if(params) {
        return await apiClient.get(API_URL.member.base, {params});
    } else {
        return Promise.reject('NO PARAMS');
    }

}

// NEW :: member detail get Api
export const MemberDetailGetApi = async<T extends MemberGetPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(`${API_URL.member.base}/${params.id}`);
}

// NEW :: member put Api
export const MemberPutApi = async<T extends MemberPutPayload> (data: T): Promise<T['response']> => {
    return await apiClient.put(`${API_URL.member.base}/${data.id}`, data);
}

// NEW :: member delete Api
export const MemberDeleteApi = async <T extends MemberDeletePayload>(data: T): Promise<T['response']> => {
    return await apiClient.delete(API_URL.member.base, {data});
}

// TODO NEW :: member temp password put Api
export const MemberTempPasswordPutApi = async<T extends MemberStringPutPayload> (data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.member.tempPwd, data);
}

// TODO NEW :: member change password put Api
export const MemberChangePasswordPutApi = async<T extends MemberPasswordPutPayload> (data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.member.changePwd, data);
}

export const MemberResetPasswordPutApi = async<T extends MemberResetPasswordPutPayload> (data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.member.resetPwd, data);
}

// NEW :: member invite post Api
export const MemberInvitePostApi = async<T extends MemberPayload> (data: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.invite.base, data);
}

// NEW :: member invite list get Api
export const MemberInviteListGetApi = async<T extends MemberInviteListPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.member.invite.list, {params});
}

// NEW :: member invite info get Api
export const MemberInviteInfoGetApi = async<T extends MemberInviteInfoPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.member.invite.base + '/' + params.mailCode, {params});
}

// NEW :: member invite delete Api
export const MemberInviteDeleteApi = async<T extends MemberInviteInfoPayload> (params: T): Promise<T['response']> => {
    return await apiClient.delete(API_URL.member.invite.list + '/' + params.mailCode, {params});
}

// NEW :: member add shop post Api
export const MemberAddShopPostApi = async<T extends MemberPayload> (data: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.member.invite.shop, data);
}

// NEW :: member shop invite info get Api
export const MemberShopInviteInfoGetApi = async<T extends MemberInviteInfoPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.member.invite.shop + '/' + params.mailCode, {params});
}

// NEW :: role get list Api
export const RoleListGetApi = async<T extends RoleListGetPayload> (): Promise<T['response']> => {
    return await apiClient.get(API_URL.role);
}

// NEW :: role post Api
export const RolePostApi = async<T extends RolePayload> (data: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.role, data);
}

// member certify access
export const MemberCertifyAccessPutApi = async<T extends MemberAccessPutPayload> (data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.member.certify, data);
}


export const MemberPutApiInMyMenu = async<T extends MemberPutPayload> (data: T): Promise<T['response']> => {
    //2025.10.20 Master space 이동으로 생성
    return await apiSpaceClient.put(`${API_URL.member.base}/${data.id}`, data);
}
export const MemberMeGetApiInMyMenu = async<T extends MemberMePayload> (params: T): Promise<T['response']> => {
    //2025.10.20 Master space 이동으로 생성
    return await apiSpaceClient.get(API_URL.member.me, {params});
}
export const MemberChangePasswordPutApiInMyMenu = async<T extends MemberPasswordPutPayload> (data: T): Promise<T['response']> => {
    //2025.10.20 Master space 이동으로 생성
    return await apiSpaceClient.put(API_URL.member.changePwd, data);
}

export const MemberCertifyAccessPutApiByMaster = async<T extends MemberAccessPutPayload> (data: T): Promise<T['response']> => {
    //2025.12.18 Master 개인정보이력관리 로그 남기기
    return await apiSpaceClient.put(API_URL.member.certify, data);
}

// NEW :: member password expireAt extend Api
export const MemberPwdChangePutApi = async <T extends MemberPutPayload>(data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.member.extendsPwdChangeDate, data);
}